// // // import React, { useEffect, useState, useCallback } from 'react';
// // // import {
// // //   Box, Typography, Chip, IconButton, Tooltip, Button,
// // // } from '@mui/material';
// // // import HistoryIcon from '@mui/icons-material/History';
// // // import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
// // // import TableComponent from '../../../Components/TableComponent/TableComponent';
// // // import { LoadingSpinner } from '../../../Components/spinner/spinner';
// // // import { SnackBarComponent } from '../../../Components/snackBar/snackBar';

// // // import {
// // //   fetchMyQueue, STAGES, STAGE_LABELS, STAGE_COLORS,
// // //   GENERIC_FORWARD_RETURN_ROLES,
// // // } from './workflowApi';
// // // import CaseWorkerDecisionDialog from './caseworkerDecisionDialog';
// // // import ForensicAuditorActionDialog from './forensicAuditorActionDialog';
// // // import ForwardReturnDialog from './forwordReturnDialog';
// // // import WorkflowHistoryDialog from './workHistoryDialog';
// // // import ExcessManageModal from './epmsMgmtModal'; // existing payment/docs modal, reused at pending_payment stage

// // // // role: normalized role string ('case_worker' | 'forensic_auditor' | 'shirastedar' |
// // // //        'tahsildar' | 'assistant_commissioner' | 'competent_authority' | 'sploca')
// // // const WorkflowQueueTable = ({ role, title }) => {
// // //   const [rows, setRows] = useState([]);
// // //   const [loading, setLoading] = useState(false);
// // //   const [activeRow, setActiveRow] = useState(null);
// // //   const [dialogType, setDialogType] = useState(null); // 'action' | 'history' | 'manage'

// // //   const [snackbarOpen, setSnackbarOpen] = useState(false);
// // //   const [snackbarMsg, setSnackbarMsg] = useState('');
// // //   const [snackbarSeverity, setSnackbarSeverity] = useState('info');

// // //   const showSuccess = (msg) => { setSnackbarMsg(msg); setSnackbarSeverity('success'); setSnackbarOpen(true); };
// // //   const showError = (msg) => { setSnackbarMsg(msg); setSnackbarSeverity('error'); setSnackbarOpen(true); };

// // //   const loadQueue = useCallback(() => {
// // //     setLoading(true);
// // //     fetchMyQueue()
// // //       .then((res) => setRows(res.data?.results || []))
// // //       .catch(() => showError('Failed to load your queue.'))
// // //       .finally(() => setLoading(false));
// // //   }, []);

// // //   useEffect(() => { loadQueue(); }, [loadQueue]);

// // //   const closeDialogs = () => {
// // //     setActiveRow(null);
// // //     setDialogType(null);
// // //   };

// // //   const handleDialogSuccess = (msg) => {
// // //     showSuccess(msg);
// // //     closeDialogs();
// // //     loadQueue();
// // //   };

// // //   const openAction = (row) => {
// // //     setActiveRow(row);
// // //     setDialogType('action');
// // //   };

// // //   const openHistory = (row) => {
// // //     setActiveRow(row);
// // //     setDialogType('history');
// // //   };

// // //   const actionButtonLabel = (stage) => {
// // //     if (stage === STAGES.PENDING_CASE_WORKER) return 'Submit Decision';
// // //     if (stage === STAGES.PENDING_PAYMENT) return 'Manage Payment';
// // //     return 'Review';
// // //   };

// // //   const handleActionClick = (row) => {
// // //     if (row.current_stage === STAGES.PENDING_PAYMENT) {
// // //       setActiveRow(row);
// // //       setDialogType('manage'); // reuse existing ExcessManageModal for payment/closure
// // //       return;
// // //     }
// // //     openAction(row);
// // //   };

// // //   const columns = [
// // //     { id: 'reference_id', field: 'reference_id', headerName: 'Reference ID', width: 150 },
// // //     { id: 'name', field: 'name', headerName: 'Name', width: 160 },
// // //     { id: 'fe_name', field: 'fe_name', headerName: 'FE', width: 160 },
// // //     {
// // //       id: 'workflow_type', field: 'workflow_type', headerName: 'Workflow', width: 110,
// // //       renderCell: (params) => params.row.workflow_type
// // //         ? <Chip size="small" label={params.row.workflow_type === 'workflow_1' ? 'WF 1' : 'WF 2'} />
// // //         : <Typography variant="caption" color="text.secondary">—</Typography>,
// // //     },
// // //     {
// // //       id: 'current_stage', field: 'current_stage', headerName: 'Stage', width: 220,
// // //       renderCell: (params) => (
// // //         <Chip
// // //           size="small"
// // //           label={STAGE_LABELS[params.row.current_stage] || params.row.current_stage}
// // //           color={STAGE_COLORS[params.row.current_stage] || 'default'}
// // //           sx={{ fontWeight: 600 }}
// // //         />
// // //       ),
// // //     },
// // //     { id: 'excess_amount', field: 'excess_amount', headerName: 'Excess Amount', width: 140 },
// // //     {
// // //       id: 'actions', field: 'actions', headerName: 'Actions', width: 200, sortable: false,
// // //       renderCell: (params) => (
// // //         <Box display="flex" alignItems="center" gap={0.5}>
// // //           <Button
// // //             size="small"
// // //             variant="contained"
// // //             startIcon={<AssignmentTurnedInIcon fontSize="small" />}
// // //             onClick={() => handleActionClick(params.row)}
// // //           >
// // //             {actionButtonLabel(params.row.current_stage)}
// // //           </Button>
// // //           <Tooltip title="View History">
// // //             <IconButton size="small" onClick={() => openHistory(params.row)}>
// // //               <HistoryIcon fontSize="small" />
// // //             </IconButton>
// // //           </Tooltip>
// // //         </Box>
// // //       ),
// // //     },
// // //   ];

// // //   const isGenericRole = GENERIC_FORWARD_RETURN_ROLES.has(role);

// // //   return (
// // //     <Box sx={{ width: '100%', bgcolor: '#fff', borderRadius: 2, boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
// // //       <Box p={2} display="flex" justifyContent="space-between" alignItems="center" bgcolor="rgba(195,234,203,0.1)">
// // //         <Typography variant="h6" fontWeight="bold">{title}</Typography>
// // //         <Typography variant="body2" color="text.secondary">
// // //           {rows.length} case(s) awaiting your action
// // //         </Typography>
// // //       </Box>

// // //       {loading ? (
// // //         <LoadingSpinner size={30} />
// // //       ) : rows.length === 0 ? (
// // //         <Box p={4} textAlign="center">
// // //           <Typography color="text.secondary">Nothing pending in your queue right now.</Typography>
// // //         </Box>
// // //       ) : (
// // //         <TableComponent
// // //           columns={columns}
// // //           rows={rows}
// // //           manageColumnStatus
// // //           enableSort
// // //           sx={{ '& .MuiDataGrid-columnHeaders': { backgroundColor: '#1976d2', color: '#fff', fontWeight: 'bold' } }}
// // //         />
// // //       )}

// // //       {/* Case Worker — initial decision */}
// // //       {activeRow && dialogType === 'action' && role === 'case_worker' && (
// // //         <CaseWorkerDecisionDialog
// // //           open
// // //           onClose={closeDialogs}
// // //           excessId={activeRow.id}
// // //           refId={activeRow.reference_id}
// // //           onSuccess={handleDialogSuccess}
// // //           onError={showError}
// // //         />
// // //       )}

// // //       {/* Forensic Auditor — report + forward/return */}
// // //       {activeRow && dialogType === 'action' && role === 'forensic_auditor' && (
// // //         <ForensicAuditorActionDialog
// // //           open
// // //           onClose={closeDialogs}
// // //           excessId={activeRow.id}
// // //           refId={activeRow.reference_id}
// // //           excessAmt={activeRow.excess_amount}
// // //           onSuccess={handleDialogSuccess}
// // //           onError={showError}
// // //         />
// // //       )}

// // //       {/* Shirastedar / Tahsildar / AC / CA / SPLOCA — generic forward/return */}
// // //       {activeRow && dialogType === 'action' && isGenericRole && (
// // //         <ForwardReturnDialog
// // //           open
// // //           onClose={closeDialogs}
// // //           excessId={activeRow.id}
// // //           refId={activeRow.reference_id}
// // //           role={role}
// // //           currentStage={activeRow.current_stage}
// // //           stageLabel={STAGE_LABELS[activeRow.current_stage] || activeRow.current_stage}
// // //           onSuccess={handleDialogSuccess}
// // //           onError={showError}
// // //         />
// // //       )}

// // //       {/* Case Worker at pending_payment — reuse the existing manage modal */}
// // //       {activeRow && dialogType === 'manage' && (
// // //         <ExcessManageModal
// // //           open
// // //           onClose={closeDialogs}
// // //           excessId={activeRow.id}
// // //           refId={activeRow.reference_id}
// // //           excessAmt={activeRow.excess_amount}
// // //         />
// // //       )}

// // //       {/* History — available to everyone */}
// // //       {activeRow && dialogType === 'history' && (
// // //         <WorkflowHistoryDialog
// // //           open
// // //           onClose={closeDialogs}
// // //           excessId={activeRow.id}
// // //           refId={activeRow.reference_id}
// // //         />
// // //       )}

// // //       <SnackBarComponent
// // //         open={snackbarOpen}
// // //         message={snackbarMsg}
// // //         severity={snackbarSeverity}
// // //         onClose={() => setSnackbarOpen(false)}
// // //       />
// // //     </Box>
// // //   );
// // // };

// // // export default WorkflowQueueTable;



// // import React, { useEffect, useState, useCallback } from 'react';
// // import {
// //   Box, Typography, Chip, IconButton, Tooltip, Button,
// //   FormControl, InputLabel, Select, MenuItem,
// // } from '@mui/material';
// // import HistoryIcon from '@mui/icons-material/History';
// // import VisibilityIcon from '@mui/icons-material/Visibility';
// // import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
// // import TableComponent from '../../../Components/TableComponent/TableComponent';
// // import { LoadingSpinner } from '../../../Components/spinner/spinner';
// // import { SnackBarComponent } from '../../../Components/snackBar/snackBar';

// // import {
// //   fetchMyQueue, fetchMyFeList, STAGES, STAGE_LABELS, STAGE_COLORS,
// //   GENERIC_FORWARD_RETURN_ROLES,
// // } from './workflowApi';

// // import CaseWorkerDecisionDialog from './caseworkerDecisionDialog';
// // import ForensicAuditorActionDialog from './forensicAuditorActionDialog';
// // import ForwardReturnDialog from './forwordReturnDialog';
// // import WorkflowHistoryDialog from './workHistoryDialog';
// // import ExcessManageModal from './epmsMgmtModal';

// // import RecordDetailDialog from './recordDetails';


// // // const fmtMoney = (n) => `₹ ${Number(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;

// // const fmtMoney = (n) => `₹ ${Number(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;

// // const FE_FILTERABLE_ROLES = new Set(['competent_authority', 'sploca']);

// // // role: normalized role string ('case_worker' | 'forensic_auditor' | 'shirastedar' |
// // //        'tahsildar' | 'assistant_commissioner' | 'competent_authority' | 'sploca')
// // //
// // // Optional props for splitting a role's queue into separate tabs:
// // //   stageOverride    — restrict to one specific stage (e.g. Case Worker's
// // //                       "Payment Settlement" tab only wants pending_payment)
// // //   onlyReturned      — only cases sent back for correction ("Returned" tab)
// // //   excludeReturned   — hide cases sent back for correction (the main tab,
// // //                       so a case doesn't appear in two tabs at once)
// // const WorkflowQueueTable = ({
// //   role, title, stageOverride, onlyReturned, excludeReturned,
// // }) => {
// //   const [rows, setRows] = useState([]);
// //   const [loading, setLoading] = useState(false);
// //   const [activeRow, setActiveRow] = useState(null);
// //   const [dialogType, setDialogType] = useState(null); // 'action' | 'history' | 'manage' | 'detail'

// //   const [feOptions, setFeOptions] = useState([]);
// //   const [selectedFeId, setSelectedFeId] = useState('');
// //   const isFeFilterable = FE_FILTERABLE_ROLES.has(role);

// //   const [snackbarOpen, setSnackbarOpen] = useState(false);
// //   const [snackbarMsg, setSnackbarMsg] = useState('');
// //   const [snackbarSeverity, setSnackbarSeverity] = useState('info');

// //   const showSuccess = (msg) => { setSnackbarMsg(msg); setSnackbarSeverity('success'); setSnackbarOpen(true); };
// //   const showError = (msg) => { setSnackbarMsg(msg); setSnackbarSeverity('error'); setSnackbarOpen(true); };

// //   useEffect(() => {
// //     if (!isFeFilterable) return;
// //     fetchMyFeList()
// //       .then((res) => setFeOptions(res.data?.results || []))
// //       .catch(() => setFeOptions([]));
// //   }, [isFeFilterable]);

// //   const loadQueue = useCallback(() => {
// //     setLoading(true);
// //     fetchMyQueue({ stage: stageOverride, onlyReturned, excludeReturned, feId: selectedFeId || undefined })
// //       .then((res) => setRows(res.data?.results || []))
// //       .catch(() => showError('Failed to load your queue.'))
// //       .finally(() => setLoading(false));
// //   }, [stageOverride, onlyReturned, excludeReturned, selectedFeId]);

// //   useEffect(() => { loadQueue(); }, [loadQueue]);

// //   const closeDialogs = () => {
// //     setActiveRow(null);
// //     setDialogType(null);
// //   };

// //   const handleDialogSuccess = (msg) => {
// //     showSuccess(msg);
// //     closeDialogs();
// //     loadQueue();
// //   };

// //   const openAction = (row) => {
// //     setActiveRow(row);
// //     setDialogType('action');
// //   };

// //   const openHistory = (row) => {
// //     setActiveRow(row);
// //     setDialogType('history');
// //   };

// //   const openDetail = (row) => {
// //     setActiveRow(row);
// //     setDialogType('detail');
// //   };

// //   const actionButtonLabel = (stage) => {
// //     if (stage === STAGES.PENDING_CASE_WORKER) return 'Submit Decision';
// //     if (stage === STAGES.PENDING_PAYMENT) return 'Manage Payment';
// //     return 'Review';
// //   };

// //   const handleActionClick = (row) => {
// //     if (row.current_stage === STAGES.PENDING_PAYMENT) {
// //       setActiveRow(row);
// //       setDialogType('manage'); // reuse existing ExcessManageModal for payment/closure
// //       return;
// //     }
// //     openAction(row);
// //   };

// //   const columns = [
// //     { id: 'reference_id', field: 'reference_id', headerName: 'Reference ID', width: 150 },
// //     { id: 'name', field: 'name', headerName: 'Name', width: 150 },
// //     { id: 'fe_name', field: 'fe_name', headerName: 'FE', width: 150 },
// //     {
// //       id: 'workflow_type', field: 'workflow_type', headerName: 'Workflow', width: 100,
// //       renderCell: (params) => params.row.workflow_type
// //         ? <Chip size="small" label={params.row.workflow_type === 'workflow_1' ? 'WF 1' : 'WF 2'} />
// //         : <Typography variant="caption" color="text.secondary">—</Typography>,
// //     },
// //     {
// //       id: 'current_stage', field: 'current_stage', headerName: 'Stage', width: 200,
// //       renderCell: (params) => (
// //         <Box display="flex" alignItems="center" gap={0.5}>
// //           <Chip
// //             size="small"
// //             label={STAGE_LABELS[params.row.current_stage] || params.row.current_stage}
// //             color={STAGE_COLORS[params.row.current_stage] || 'default'}
// //             sx={{ fontWeight: 600 }}
// //           />
// //           {params.row.is_returned && (
// //             <Chip size="small" label="Returned" color="error" variant="outlined" sx={{ fontWeight: 600 }} />
// //           )}
// //         </Box>
// //       ),
// //     },
// //     {
// //       id: 'agree_to_pay', field: 'agree_to_pay', headerName: 'Agreed to Pay', width: 130,
// //       renderCell: (params) => {
// //         const p = params.row.payment;
// //         if (!p) return <Typography variant="caption" color="text.secondary">—</Typography>;
// //         if (p.is_agreed_to_pay) return <Chip size="small" label="Agreed" color="success" />;
// //         if (p.is_not_agreed_to_pay) return <Chip size="small" label="Not Agreed" color="error" />;
// //         return <Chip size="small" label="Pending" variant="outlined" />;
// //       },
// //     },
// //     {
// //       id: 'agreed_amount', field: 'agreed_amount', headerName: 'Agreed Amount', width: 140,
// //       renderCell: (params) => params.row.payment?.agreed_amount
// //         ? fmtMoney(params.row.payment.agreed_amount)
// //         : <Typography variant="caption" color="text.secondary">—</Typography>,
// //     },
// //     {
// //       id: 'no_of_installment', field: 'no_of_installment', headerName: 'Installments', width: 110,
// //       renderCell: (params) => params.row.payment?.no_of_installment || (
// //         <Typography variant="caption" color="text.secondary">—</Typography>
// //       ),
// //     },
// //     {
// //       id: 'excess_amount', field: 'excess_amount', headerName: 'Excess Amount', width: 140,
// //       renderCell: (params) => fmtMoney(params.row.excess_amount),
// //     },
// //     {
// //       id: 'actions', field: 'actions', headerName: 'Actions', width: 240, sortable: false,
// //       renderCell: (params) => (
// //         <Box display="flex" alignItems="center" gap={0.5}>
// //           <Button
// //             size="small"
// //             variant="contained"
// //             startIcon={<AssignmentTurnedInIcon fontSize="small" />}
// //             onClick={() => handleActionClick(params.row)}
// //           >
// //             {actionButtonLabel(params.row.current_stage)}
// //           </Button>
// //           <Tooltip title="View full details">
// //             <IconButton size="small" onClick={() => openDetail(params.row)}>
// //               <VisibilityIcon fontSize="small" />
// //             </IconButton>
// //           </Tooltip>
// //           <Tooltip title="View History">
// //             <IconButton size="small" onClick={() => openHistory(params.row)}>
// //               <HistoryIcon fontSize="small" />
// //             </IconButton>
// //           </Tooltip>
// //         </Box>
// //       ),
// //     },
// //   ];

// //   const isGenericRole = GENERIC_FORWARD_RETURN_ROLES.has(role);

// //   return (
// //     <Box sx={{ width: '100%', bgcolor: '#fff', borderRadius: 2, boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
// //       <Box p={2} display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={1.5} bgcolor="rgba(195,234,203,0.1)">
// //         <Typography variant="h6" fontWeight="bold">{title}</Typography>
// //         <Box display="flex" alignItems="center" gap={2}>
// //           {isFeFilterable && (
// //             <FormControl size="small" sx={{ minWidth: 220 }}>
// //               <InputLabel>Filter by FE</InputLabel>
// //               <Select
// //                 label="Filter by FE"
// //                 value={selectedFeId}
// //                 onChange={(e) => setSelectedFeId(e.target.value)}
// //                 displayEmpty
// //               >
// //                 <MenuItem value=""><em>All FE{role === 'sploca' ? ' (State-wide)' : ''}</em></MenuItem>
// //                 {feOptions.map((fe) => (
// //                   <MenuItem key={fe.id} value={fe.id}>{fe.name}</MenuItem>
// //                 ))}
// //               </Select>
// //             </FormControl>
// //           )}
// //           <Typography variant="body2" color="text.secondary">
// //             {rows.length} case(s) {onlyReturned ? 'returned to you' : 'awaiting your action'}
// //           </Typography>
// //         </Box>
// //       </Box>

// //       {loading ? (
// //         <LoadingSpinner size={30} />
// //       ) : rows.length === 0 ? (
// //         <Box p={4} textAlign="center">
// //           <Typography color="text.secondary">
// //             {onlyReturned ? 'Nothing has been returned to you.' : 'Nothing pending in your queue right now.'}
// //           </Typography>
// //         </Box>
// //       ) : (
// //         <TableComponent
// //           columns={columns}
// //           rows={rows}
// //           manageColumnStatus
// //           enableSort
// //           sx={{ '& .MuiDataGrid-columnHeaders': { backgroundColor: '#1976d2', color: '#fff', fontWeight: 'bold' } }}
// //         />
// //       )}

// //       {/* Detail view — always available */}
// //       {activeRow && dialogType === 'detail' && (
// //         <RecordDetailDialog open onClose={closeDialogs} record={activeRow} />
// //       )}

// //       {/* Case Worker — initial decision */}
// //       {activeRow && dialogType === 'action' && role === 'case_worker' && (
// //         <CaseWorkerDecisionDialog
// //           open
// //           onClose={closeDialogs}
// //           excessId={activeRow.id}
// //           refId={activeRow.reference_id}
// //           excessAmt={activeRow.excess_amount}
// //           onSuccess={handleDialogSuccess}
// //           onError={showError}
// //         />
// //       )}

// //       {/* Forensic Auditor — report + forward/return */}
// //       {activeRow && dialogType === 'action' && role === 'forensic_auditor' && (
// //         <ForensicAuditorActionDialog
// //           open
// //           onClose={closeDialogs}
// //           excessId={activeRow.id}
// //           refId={activeRow.reference_id}
// //           excessAmt={activeRow.excess_amount}
// //           onSuccess={handleDialogSuccess}
// //           onError={showError}
// //         />
// //       )}

// //       {/* Shirastedar / Tahsildar / AC / CA / SPLOCA — generic forward/return */}
// //       {activeRow && dialogType === 'action' && isGenericRole && (
// //         <ForwardReturnDialog
// //           open
// //           onClose={closeDialogs}
// //           excessId={activeRow.id}
// //           refId={activeRow.reference_id}
// //           role={role}
// //           currentStage={activeRow.current_stage}
// //           stageLabel={STAGE_LABELS[activeRow.current_stage] || activeRow.current_stage}
// //           onSuccess={handleDialogSuccess}
// //           onError={showError}
// //         />
// //       )}

// //       {/* Case Worker at pending_payment — reuse the existing manage modal */}
// //       {activeRow && dialogType === 'manage' && (
// //         <ExcessManageModal
// //           open
// //           onClose={closeDialogs}
// //           excessId={activeRow.id}
// //           refId={activeRow.reference_id}
// //           excessAmt={activeRow.excess_amount}
// //         />
// //       )}

// //       {/* History — available to everyone */}
// //       {activeRow && dialogType === 'history' && (
// //         <WorkflowHistoryDialog
// //           open
// //           onClose={closeDialogs}
// //           excessId={activeRow.id}
// //           refId={activeRow.reference_id}
// //         />
// //       )}

// //       <SnackBarComponent
// //         open={snackbarOpen}
// //         message={snackbarMsg}
// //         severity={snackbarSeverity}
// //         onClose={() => setSnackbarOpen(false)}
// //       />
// //     </Box>
// //   );
// // };

// // export default WorkflowQueueTable;


// import React, { useEffect, useState, useCallback } from 'react';
// import {
//   Box, Typography, Chip, IconButton, Tooltip, Button,
//   FormControl, InputLabel, Select, MenuItem,
// } from '@mui/material';
// import HistoryIcon from '@mui/icons-material/History';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
// import TableComponent from '../../../Components/TableComponent/TableComponent';
// import { LoadingSpinner } from '../../../Components/spinner/spinner';
// import { SnackBarComponent } from '../../../Components/snackBar/snackBar';

// import {
//   fetchMyQueue, fetchMyFeList, STAGES, STAGE_LABELS, STAGE_COLORS,
//   GENERIC_FORWARD_RETURN_ROLES,
// } from './workflowApi';
// import CaseWorkerDecisionDialog from './caseworkerDecisionDialog';
// import ForensicAuditorActionDialog from './forensicAuditorActionDialog';
// import ForwardReturnDialog from './forwordReturnDialog';
// import WorkflowHistoryDialog from './workHistoryDialog';
// import RecordDetailDialog from './recordDetails';
// import ExcessManageModal from './epmsMgmtModal';

// const fmtMoney = (n) => `₹ ${Number(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;

// const FE_FILTERABLE_ROLES = new Set(['competent_authority', 'sploca']);

// // role: normalized role string ('case_worker' | 'forensic_auditor' | 'shirastedar' |
// //        'tahsildar' | 'assistant_commissioner' | 'competent_authority' | 'sploca')
// //
// // Optional props for splitting a role's queue into separate tabs:
// //   stageOverride    — restrict to one specific stage (e.g. Case Worker's
// //                       "Payment Settlement" tab only wants pending_payment)
// //   onlyReturned      — only cases sent back for correction ("Returned" tab)
// //   excludeReturned   — hide cases sent back for correction (the main tab,
// //                       so a case doesn't appear in two tabs at once)
// const WorkflowQueueTable = ({
//   role, title, stageOverride, onlyReturned, excludeReturned,
// }) => {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [activeRow, setActiveRow] = useState(null);
//   const [dialogType, setDialogType] = useState(null); // 'action' | 'history' | 'manage' | 'detail'

//   const [feOptions, setFeOptions] = useState([]);
//   const [selectedFeId, setSelectedFeId] = useState('');
//   const isFeFilterable = FE_FILTERABLE_ROLES.has(role);

//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMsg, setSnackbarMsg] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('info');

//   const showSuccess = (msg) => { setSnackbarMsg(msg); setSnackbarSeverity('success'); setSnackbarOpen(true); };
//   const showError = (msg) => { setSnackbarMsg(msg); setSnackbarSeverity('error'); setSnackbarOpen(true); };

//   useEffect(() => {
//     if (!isFeFilterable) return;
//     fetchMyFeList()
//       .then((res) => setFeOptions(res.data?.results || []))
//       .catch(() => setFeOptions([]));
//   }, [isFeFilterable]);

//   const loadQueue = useCallback(() => {
//     setLoading(true);
//     fetchMyQueue({ stage: stageOverride, onlyReturned, excludeReturned, feId: selectedFeId || undefined })
//       .then((res) => setRows(res.data?.results || []))
//       .catch(() => showError('Failed to load your queue.'))
//       .finally(() => setLoading(false));
//   }, [stageOverride, onlyReturned, excludeReturned, selectedFeId]);

//   useEffect(() => { loadQueue(); }, [loadQueue]);

//   const closeDialogs = () => {
//     setActiveRow(null);
//     setDialogType(null);
//   };

//   const handleDialogSuccess = (msg) => {
//     showSuccess(msg);
//     closeDialogs();
//     loadQueue();
//   };

//   const openAction = (row) => {
//     setActiveRow(row);
//     setDialogType('action');
//   };

//   const openHistory = (row) => {
//     setActiveRow(row);
//     setDialogType('history');
//   };

//   const openDetail = (row) => {
//     setActiveRow(row);
//     setDialogType('detail');
//   };

//   const actionButtonLabel = (stage) => {
//     if (stage === STAGES.PENDING_CASE_WORKER) return 'Submit Decision';
//     if (stage === STAGES.PENDING_PAYMENT) return 'Manage Payment';
//     return 'Review';
//   };

//   const handleActionClick = (row) => {
//     if (row.current_stage === STAGES.PENDING_PAYMENT) {
//       setActiveRow(row);
//       setDialogType('manage'); // reuse existing ExcessManageModal for payment/closure
//       return;
//     }
//     openAction(row);
//   };

//   const columns = [
//     { id: 'reference_id', field: 'reference_id', headerName: 'Reference ID', width: 150 },
//     { id: 'name', field: 'name', headerName: 'Name', width: 150 },
//     { id: 'fe_name', field: 'fe_name', headerName: 'FE', width: 150 },
//     {
//       id: 'workflow_type', field: 'workflow_type', headerName: 'Workflow', width: 100,
//       renderCell: (params) => params.row.workflow_type
//         ? <Chip size="small" label={params.row.workflow_type === 'workflow_1' ? 'WF 1' : 'WF 2'} />
//         : <Typography variant="caption" color="text.secondary">—</Typography>,
//     },
//     {
//       id: 'current_stage', field: 'current_stage', headerName: 'Stage', width: 200,
//       renderCell: (params) => (
//         <Box display="flex" alignItems="center" gap={0.5}>
//           <Chip
//             size="small"
//             label={STAGE_LABELS[params.row.current_stage] || params.row.current_stage}
//             color={STAGE_COLORS[params.row.current_stage] || 'default'}
//             sx={{ fontWeight: 600 }}
//           />
//           {params.row.is_returned && (
//             <Chip size="small" label="Returned" color="error" variant="outlined" sx={{ fontWeight: 600 }} />
//           )}
//         </Box>
//       ),
//     },
//     {
//       id: 'agree_to_pay', field: 'agree_to_pay', headerName: 'Agreed to Pay', width: 130,
//       renderCell: (params) => {
//         const p = params.row.payment;
//         if (!p) return <Typography variant="caption" color="text.secondary">—</Typography>;
//         if (p.is_agreed_to_pay) return <Chip size="small" label="Agreed" color="success" />;
//         if (p.is_not_agreed_to_pay) return <Chip size="small" label="Not Agreed" color="error" />;
//         return <Chip size="small" label="Pending" variant="outlined" />;
//       },
//     },
//     {
//       id: 'agreed_amount', field: 'agreed_amount', headerName: 'Agreed Amount', width: 140,
//       renderCell: (params) => params.row.payment?.agreed_amount
//         ? fmtMoney(params.row.payment.agreed_amount)
//         : <Typography variant="caption" color="text.secondary">—</Typography>,
//     },
//     {
//       id: 'no_of_installment', field: 'no_of_installment', headerName: 'Installments', width: 110,
//       renderCell: (params) => params.row.payment?.no_of_installment || (
//         <Typography variant="caption" color="text.secondary">—</Typography>
//       ),
//     },
//     {
//       id: 'excess_amount', field: 'excess_amount', headerName: 'Excess Amount', width: 140,
//       renderCell: (params) => fmtMoney(params.row.excess_amount),
//     },
//     {
//       id: 'actions', field: 'actions', headerName: 'Actions', width: 240, sortable: false,
//       renderCell: (params) => (
//         <Box display="flex" alignItems="center" gap={0.5}>
//           <Button
//             size="small"
//             variant="contained"
//             startIcon={<AssignmentTurnedInIcon fontSize="small" />}
//             onClick={() => handleActionClick(params.row)}
//           >
//             {actionButtonLabel(params.row.current_stage)}
//           </Button>
//           <Tooltip title="View full details">
//             <IconButton size="small" onClick={() => openDetail(params.row)}>
//               <VisibilityIcon fontSize="small" />
//             </IconButton>
//           </Tooltip>
//           <Tooltip title="View History">
//             <IconButton size="small" onClick={() => openHistory(params.row)}>
//               <HistoryIcon fontSize="small" />
//             </IconButton>
//           </Tooltip>
//         </Box>
//       ),
//     },
//   ];

//   const isGenericRole = GENERIC_FORWARD_RETURN_ROLES.has(role);

//   return (
//     <Box sx={{ width: '100%', bgcolor: '#fff', borderRadius: 2, boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
//       <Box p={2} display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={1.5} bgcolor="rgba(195,234,203,0.1)">
//         <Typography variant="h6" fontWeight="bold">{title}</Typography>
//         <Box display="flex" alignItems="center" gap={2}>
//           {isFeFilterable && (
//             <FormControl size="small" sx={{ minWidth: 220 }}>
//               <InputLabel>Filter by FE</InputLabel>
//               <Select
//                 label="Filter by FE"
//                 value={selectedFeId}
//                 onChange={(e) => setSelectedFeId(e.target.value)}
//                 displayEmpty
//               >
//                 <MenuItem value=""><em>All FE{role === 'sploca' ? ' (State-wide)' : ''}</em></MenuItem>
//                 {feOptions.map((fe) => (
//                   <MenuItem key={fe.id} value={fe.id}>{fe.name}</MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           )}
//           <Typography variant="body2" color="text.secondary">
//             {rows.length} case(s) {onlyReturned ? 'returned to you' : 'awaiting your action'}
//           </Typography>
//         </Box>
//       </Box>

//       {loading ? (
//         <LoadingSpinner size={30} />
//       ) : rows.length === 0 ? (
//         <Box p={4} textAlign="center">
//           <Typography color="text.secondary">
//             {onlyReturned ? 'Nothing has been returned to you.' : 'Nothing pending in your queue right now.'}
//           </Typography>
//         </Box>
//       ) : (
//         <TableComponent
//           columns={columns}
//           rows={rows}
//           manageColumnStatus
//           enableSort
//           sx={{ '& .MuiDataGrid-columnHeaders': { backgroundColor: '#1976d2', color: '#fff', fontWeight: 'bold' } }}
//         />
//       )}

//       {/* Detail view — always available */}
//       {activeRow && dialogType === 'detail' && (
//         <RecordDetailDialog open onClose={closeDialogs} record={activeRow} />
//       )}

//       {/* Case Worker — initial decision */}
//       {activeRow && dialogType === 'action' && role === 'case_worker' && (
//         <CaseWorkerDecisionDialog
//           open
//           onClose={closeDialogs}
//           excessId={activeRow.id}
//           refId={activeRow.reference_id}
//           excessAmt={activeRow.excess_amount}
//           onSuccess={handleDialogSuccess}
//           onError={showError}
//         />
//       )}

//       {/* Forensic Auditor — report + forward/return */}
//       {activeRow && dialogType === 'action' && role === 'forensic_auditor' && (
//         <ForensicAuditorActionDialog
//           open
//           onClose={closeDialogs}
//           excessId={activeRow.id}
//           refId={activeRow.reference_id}
//           excessAmt={activeRow.excess_amount}
//           onSuccess={handleDialogSuccess}
//           onError={showError}
//         />
//       )}

//       {/* Shirastedar / Tahsildar / AC / CA / SPLOCA — generic forward/return */}
//       {activeRow && dialogType === 'action' && isGenericRole && (
//         <ForwardReturnDialog
//           open
//           onClose={closeDialogs}
//           excessId={activeRow.id}
//           refId={activeRow.reference_id}
//           role={role}
//           currentStage={activeRow.current_stage}
//           stageLabel={STAGE_LABELS[activeRow.current_stage] || activeRow.current_stage}
//           onSuccess={handleDialogSuccess}
//           onError={showError}
//         />
//       )}

//       {/* Case Worker at pending_payment (or closed, defensively) — reuse the existing manage modal */}
//       {activeRow && dialogType === 'manage' && (
//         <ExcessManageModal
//           open
//           onClose={closeDialogs}
//           excessId={activeRow.id}
//           refId={activeRow.reference_id}
//           excessAmt={activeRow.excess_amount}
//           readOnly={activeRow.current_stage === STAGES.CLOSED || role !== 'case_worker'}
//         />
//       )}

//       {/* History — available to everyone */}
//       {activeRow && dialogType === 'history' && (
//         <WorkflowHistoryDialog
//           open
//           onClose={closeDialogs}
//           excessId={activeRow.id}
//           refId={activeRow.reference_id}
//         />
//       )}

//       <SnackBarComponent
//         open={snackbarOpen}
//         message={snackbarMsg}
//         severity={snackbarSeverity}
//         onClose={() => setSnackbarOpen(false)}
//       />
//     </Box>
//   );
// };

// export default WorkflowQueueTable;


import React, { useEffect, useState, useCallback } from 'react';
import {
  Box, Typography, Chip, IconButton, Tooltip, Button,
  Autocomplete, TextField,
} from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import TableComponent from '../../../Components/TableComponent/TableComponent';
import { LoadingSpinner } from '../../../Components/spinner/spinner';
import { SnackBarComponent } from '../../../Components/snackBar/snackBar';

import {
  fetchMyQueue, fetchMyFeList, STAGES, STAGE_LABELS, STAGE_COLORS,
  GENERIC_FORWARD_RETURN_ROLES,
} from './workflowApi';
import CaseWorkerDecisionDialog from './caseworkerDecisionDialog';
import ForensicAuditorActionDialog from './forensicAuditorActionDialog';
import ForwardReturnDialog from './forwordReturnDialog';
import WorkflowHistoryDialog from './workHistoryDialog';
import RecordDetailDialog from './recordDetails';
import ExcessManageModal from './epmsMgmtModal';

const fmtMoney = (n) => `₹ ${Number(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;

// Roles that see multiple FEs and must actively search/select one before
// any queue data loads — there is no "All FE" default view for these roles.
// const FE_FILTERABLE_ROLES = new Set(['competent_authority', 'sploca']);

const FE_FILTERABLE_ROLES = new Set([
  'competent_authority', 'sploca',
  'tahsildar', 'assistant_commissioner', 'joint_secretary',
]);

// role: normalized role string ('case_worker' | 'forensic_auditor' | 'shirastedar' |
//        'tahsildar' | 'assistant_commissioner' | 'competent_authority' | 'sploca')
//
// Optional props for splitting a role's queue into separate tabs:
//   stageOverride    — restrict to one specific stage (e.g. Case Worker's
//                       "Payment Settlement" tab only wants pending_payment)
//   onlyReturned      — only cases sent back for correction ("Returned" tab)
//   excludeReturned   — hide cases sent back for correction (the main tab,
//                       so a case doesn't appear in two tabs at once)
const WorkflowQueueTable = ({
  role, title, stageOverride, onlyReturned, excludeReturned,
}) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeRow, setActiveRow] = useState(null);
  const [dialogType, setDialogType] = useState(null); // 'action' | 'history' | 'manage' | 'detail'

  const [feOptions, setFeOptions] = useState([]);
  // Holds the whole FE object ({ id, name, ... }), not just the id — Autocomplete
  // needs the object to render the label and to match against feOptions.
  const [selectedFe, setSelectedFe] = useState(null);
  const isFeFilterable = FE_FILTERABLE_ROLES.has(role);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  const showSuccess = (msg) => { setSnackbarMsg(msg); setSnackbarSeverity('success'); setSnackbarOpen(true); };
  const showError = (msg) => { setSnackbarMsg(msg); setSnackbarSeverity('error'); setSnackbarOpen(true); };

  useEffect(() => {
    if (!isFeFilterable) return;
    fetchMyFeList()
      .then((res) => setFeOptions(res.data?.results || []))
      .catch(() => setFeOptions([]));
  }, [isFeFilterable]);

  const loadQueue = useCallback(() => {
    // For FE-filterable roles, don't fetch (and don't show) anything until
    // an FE has actually been picked — no more "all FE" default view.
    if (isFeFilterable && !selectedFe) {
      setRows([]);
      return;
    }
    setLoading(true);
    fetchMyQueue({ stage: stageOverride, onlyReturned, excludeReturned, feId: selectedFe?.id || undefined })
      .then((res) => setRows(res.data?.results || []))
      .catch(() => showError('Failed to load your queue.'))
      .finally(() => setLoading(false));
  }, [stageOverride, onlyReturned, excludeReturned, selectedFe, isFeFilterable]);

  useEffect(() => { loadQueue(); }, [loadQueue]);

  const closeDialogs = () => {
    setActiveRow(null);
    setDialogType(null);
  };

  const handleDialogSuccess = (msg) => {
    showSuccess(msg);
    closeDialogs();
    loadQueue();
  };

  const openAction = (row) => {
    setActiveRow(row);
    setDialogType('action');
  };

  const openHistory = (row) => {
    setActiveRow(row);
    setDialogType('history');
  };

  const openDetail = (row) => {
    setActiveRow(row);
    setDialogType('detail');
  };

  const actionButtonLabel = (stage) => {
    if (stage === STAGES.PENDING_CASE_WORKER) return 'Submit Decision';
    if (stage === STAGES.PENDING_PAYMENT) return 'Manage Payment';
    return 'Review';
  };

  const handleActionClick = (row) => {
    if (row.current_stage === STAGES.PENDING_PAYMENT) {
      setActiveRow(row);
      setDialogType('manage'); // reuse existing ExcessManageModal for payment/closure
      return;
    }
    openAction(row);
  };

  const columns = [
    { id: 'reference_id', field: 'reference_id', headerName: 'Reference ID', width: 150 },
    { id: 'name', field: 'name', headerName: 'Name', width: 150 },
    { id: 'fe_name', field: 'fe_name', headerName: 'FE', width: 150 },
    {
      id: 'workflow_type', field: 'workflow_type', headerName: 'Workflow', width: 100,
      renderCell: (params) => params.row.workflow_type
        ? <Chip size="small" label={params.row.workflow_type === 'workflow_1' ? 'WF 1' : 'WF 2'} />
        : <Typography variant="caption" color="text.secondary">—</Typography>,
    },
    {
      id: 'current_stage', field: 'current_stage', headerName: 'Stage', width: 200,
      renderCell: (params) => (
        <Box display="flex" alignItems="center" gap={0.5}>
          <Chip
            size="small"
            label={STAGE_LABELS[params.row.current_stage] || params.row.current_stage}
            color={STAGE_COLORS[params.row.current_stage] || 'default'}
            sx={{ fontWeight: 600 }}
          />
          {params.row.is_returned && (
            <Chip size="small" label="Returned" color="error" variant="outlined" sx={{ fontWeight: 600 }} />
          )}
        </Box>
      ),
    },
    {
      id: 'agree_to_pay', field: 'agree_to_pay', headerName: 'Agreed to Pay', width: 130,
      renderCell: (params) => {
        const p = params.row.payment;
        if (!p) return <Typography variant="caption" color="text.secondary">—</Typography>;
        if (p.is_agreed_to_pay) return <Chip size="small" label="Agreed" color="success" />;
        if (p.is_not_agreed_to_pay) return <Chip size="small" label="Not Agreed" color="error" />;
        return <Chip size="small" label="Pending" variant="outlined" />;
      },
    },
    {
      id: 'agreed_amount', field: 'agreed_amount', headerName: 'Agreed Amount', width: 140,
      renderCell: (params) => params.row.payment?.agreed_amount
        ? fmtMoney(params.row.payment.agreed_amount)
        : <Typography variant="caption" color="text.secondary">—</Typography>,
    },
    {
      id: 'no_of_installment', field: 'no_of_installment', headerName: 'Installments', width: 110,
      renderCell: (params) => params.row.payment?.no_of_installment || (
        <Typography variant="caption" color="text.secondary">—</Typography>
      ),
    },
    {
      id: 'excess_amount', field: 'excess_amount', headerName: 'Excess Amount', width: 140,
      renderCell: (params) => fmtMoney(params.row.excess_amount),
    },
    {
      id: 'actions', field: 'actions', headerName: 'Actions', width: 240, sortable: false,
      renderCell: (params) => (
        <Box display="flex" alignItems="center" gap={0.5}>
          <Button
            size="small"
            variant="contained"
            startIcon={<AssignmentTurnedInIcon fontSize="small" />}
            onClick={() => handleActionClick(params.row)}
          >
            {actionButtonLabel(params.row.current_stage)}
          </Button>
          <Tooltip title="View full details">
            <IconButton size="small" onClick={() => openDetail(params.row)}>
              <VisibilityIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="View History">
            <IconButton size="small" onClick={() => openHistory(params.row)}>
              <HistoryIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ];

  const isGenericRole = GENERIC_FORWARD_RETURN_ROLES.has(role);

  return (
    <Box sx={{ width: '100%', bgcolor: '#fff', borderRadius: 2, boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
      <Box p={2} display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={1.5} bgcolor="rgba(195,234,203,0.1)">
        <Typography variant="h6" fontWeight="bold">{title}</Typography>
        <Box display="flex" alignItems="center" gap={2}>
          {isFeFilterable && (
            <Autocomplete
              size="small"
              sx={{ minWidth: 280 }}
              options={feOptions}
              getOptionLabel={(fe) => fe?.name || ''}
              isOptionEqualToValue={(a, b) => a.id === b.id}
              value={selectedFe}
              onChange={(_, newValue) => setSelectedFe(newValue)}
              renderInput={(params) => (
                <TextField {...params} label="Search & select FE" placeholder="Type to search..." />
              )}
            />
          )}
          <Typography variant="body2" color="text.secondary">
            {rows.length} case(s) {onlyReturned ? 'returned to you' : 'awaiting your action'}
          </Typography>
        </Box>
      </Box>

      {loading ? (
        <LoadingSpinner size={30} />
      ) : isFeFilterable && !selectedFe ? (
        <Box p={4} textAlign="center">
          <SearchOffIcon sx={{ fontSize: 40, color: 'text.disabled', mb: 1 }} />
          <Typography color="text.secondary">
            Search and select an FE above to view this queue.
          </Typography>
        </Box>
      ) : rows.length === 0 ? (
        <Box p={4} textAlign="center">
          <Typography color="text.secondary">
            {onlyReturned ? 'Nothing has been returned to you.' : 'Nothing pending in your queue right now.'}
          </Typography>
        </Box>
      ) : (
        <TableComponent
          columns={columns}
          rows={rows}
          manageColumnStatus
          enableSort
          sx={{ '& .MuiDataGrid-columnHeaders': { backgroundColor: '#1976d2', color: '#fff', fontWeight: 'bold' } }}
        />
      )}

      {/* Detail view — always available */}
      {activeRow && dialogType === 'detail' && (
        <RecordDetailDialog open onClose={closeDialogs} record={activeRow} />
      )}

      {/* Case Worker — initial decision */}
      {activeRow && dialogType === 'action' && role === 'case_worker' && (
        <CaseWorkerDecisionDialog
          open
          onClose={closeDialogs}
          excessId={activeRow.id}
          refId={activeRow.reference_id}
          excessAmt={activeRow.excess_amount}
          onSuccess={handleDialogSuccess}
          onError={showError}
        />
      )}

      {/* Forensic Auditor — report + forward/return */}
      {activeRow && dialogType === 'action' && role === 'forensic_auditor' && (
        <ForensicAuditorActionDialog
          open
          onClose={closeDialogs}
          excessId={activeRow.id}
          refId={activeRow.reference_id}
          excessAmt={activeRow.excess_amount}
          onSuccess={handleDialogSuccess}
          onError={showError}
        />
      )}

      {/* Shirastedar / Tahsildar / AC / CA / SPLOCA — generic forward/return */}
      {activeRow && dialogType === 'action' && isGenericRole && (
        <ForwardReturnDialog
          open
          onClose={closeDialogs}
          excessId={activeRow.id}
          refId={activeRow.reference_id}
          role={role}
          currentStage={activeRow.current_stage}
          stageLabel={STAGE_LABELS[activeRow.current_stage] || activeRow.current_stage}
          onSuccess={handleDialogSuccess}
          onError={showError}
        />
      )}

      {/* Case Worker at pending_payment (or closed, defensively) — reuse the existing manage modal */}
      {activeRow && dialogType === 'manage' && (
        <ExcessManageModal
          open
          onClose={closeDialogs}
          excessId={activeRow.id}
          refId={activeRow.reference_id}
          excessAmt={activeRow.excess_amount}
          readOnly={activeRow.current_stage === STAGES.CLOSED || role !== 'case_worker'}
        />
      )}

      {/* History — available to everyone */}
      {activeRow && dialogType === 'history' && (
        <WorkflowHistoryDialog
          open
          onClose={closeDialogs}
          excessId={activeRow.id}
          refId={activeRow.reference_id}
        />
      )}

      <SnackBarComponent
        open={snackbarOpen}
        message={snackbarMsg}
        severity={snackbarSeverity}
        onClose={() => setSnackbarOpen(false)}
      />
    </Box>
  );
};

export default WorkflowQueueTable;